import { Component, OnInit, ViewChild } from '@angular/core';
import { SalesFileService } from '../services/sales-file.service';
import { HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SheetMappingComponent, parseCsv } from './sheet-mapping/sheet-mapping.component';
import { AppConfigService } from '../../app.config';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { ModalDirective } from 'ngx-bootstrap';
import { SalesFileType } from '../../enums/salesFileType';
import { DistributorBranchService } from '../../distributor/distributor-branch/distributor-branch.service';
import { DistributorSetupService, apiError, dayText } from '../../top-shared/distributor-setup/distributor-setup.service';
import { UploadJobService, UploadState } from '../../top-shared/upload-progress/upload-job.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'crm-sales-file',
  templateUrl: './sales-file.component.html',
  styleUrls: ['./sales-file.component.css']
})
export class SalesFileComponent implements OnInit {
  columns: any[] = [];
  progress: number;
  message: string;
  error: boolean = false;
  fileTypes: any[] = [];
  fileType: any;
  selectedDate: any;
  files: any[] = [];
  filesData: any[] = [];
  pageSize: number = this.appConfig.settings.pageSize;
  public logo = require("../../../app/assets/images/demo/Icon_Sales.png");
  //isSales: boolean = true;
  salesType: SalesFileType = SalesFileType.target;
  selectedFileId;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;

  @ViewChild('deleteOldFileModal')
  deleteOldFileModal: ModalDirective;

  applyDistributorPrice = true;
  constructor(private translateService: AppTranslationService, private alertService: AlertService,
    private readonly appConfig: AppConfigService, private salesFileService: SalesFileService,
    private distributorBranchService: DistributorBranchService,
    private distributorSetupService: DistributorSetupService, private uploadJobs: UploadJobService) { }

  /** progress of the uploads that run on this page (pharmacy sales, distributor targets); the others show it in their popup */
  uploadState: UploadState;

  ngOnInit() {
    this.getFilesType();
    this.getSalesFileData();
    this.salesFileService.getDitributors().subscribe(r => this.targetDistributors = (r as any[]) || [], () => { });
    this.distributorSetupService.levelNames().subscribe(n => {
      if (!n) return;
      this.targetCounts = this.targetCounts.map(c => c.field === 'details' ? { label: `${n.holder} parts`, field: c.field } : c);
    }, () => { });

    this.columns = [

      { field: 'name', header: 'Name' },
      { field: 'type', header: 'Type' },
      { field: 'insertDate', header: 'Insert Date' },
      { field: 'creationDate', header: 'Creation Date' }
    ];
  }

  getFilesType() {
    this.salesFileService.getAllSalesFileTypeTypes().subscribe(response => {
      debugger;
      let result = response as any[];
      this.fileTypes = result.filter(x => x.name.indexOf('Target') > -1);
    }, err => {
      console.log(err);
    });
  }

  getDitributors() {
    this.salesFileService.getDitributors().subscribe(response => {
      let result = response as any[];
      this.fileTypes = result;
    }, err => {
      console.log(err);
    });
  }

  getSalesFileData() {
    this.salesFileService.getSalesFileData().subscribe(response => {
      let result = response as any[];
      this.filesData = result;
    }, err => {
      console.log(err);
    });
  }

  getSalesFileDistributorsData() {
    this.salesFileService.getSalesFileDistributorsData().subscribe(response => {
      let result = response as any[];
      this.filesData = result;
    }, err => {
      console.log(err);
    });
  }

  getPharmacySalesFileData() {
    this.salesFileService.getPharmacySalesFileData().subscribe(response => {
      let result = response as any[];
      this.filesData = result;
    }, err => {
      console.log(err);
    });
  }

  /** The file that was uploaded for this record, under its original name. */
  downloadUploadedFile(item: any) {
    this.salesFileService.downloadUploadedFile(item.id).subscribe(response => {
      const url = window.URL.createObjectURL(response as Blob);
      const anchor = document.createElement("a");
      anchor.download = item.fileName || "sales-file.csv";
      anchor.href = url;
      anchor.click();
      window.URL.revokeObjectURL(url);
    }, () => this.alertService.showMessage("", "The uploaded file is no longer available", MessageSeverity.Error));
  }

  // ---- Distributor Target sheets: targets per distributor brick / brick and product (xlsx or csv, columns found by title)
  targetDistributors: any[] = [];
  targetDistributor: any;
  targetResult: any;
  targetBusy = false;
  private targetCheckOnly = false;
  targetCounts = [
    { label: 'Months', field: 'months' },
    { label: 'Targets (product x code / brick x month)', field: 'targets' },
    { label: 'Business unit parts', field: 'details' },
    { label: 'Units', field: 'units' },
    { label: 'Value', field: 'value' }
  ];

  get isDistributorTarget(): boolean { return this.fileType && this.fileType.name == 'DistributorTarget'; }

  pickDistributorTarget(checkOnly: boolean) {
    if (!this.fileType || this.targetBusy) return;
    this.targetCheckOnly = checkOnly;
    document.getElementById('chooseTargetFile').click();
  }

  uploadDistributorTarget(files: FileList) {
    if (!files || !files.length) return;
    this.targetBusy = true;
    this.targetResult = null;
    this.message = '';
    const distributorId = this.targetDistributor ? this.targetDistributor.id : null;
    this.uploadJobs.run(this.distributorSetupService.uploadTargets(files[0], distributorId, this.selectedDate ? dayText(this.selectedDate) : null, this.targetCheckOnly))
      .subscribe(state => {
        this.uploadState = state;
        if (!state.done) return;
        this.targetBusy = false;
        if (state.error) { this.error = true; this.message = state.error; return; }
        this.targetResult = state.result;
        if (state.result && state.result.saved) this.getSalesFileData();
      });
  }

  downloadCSVTemplate() {
    if (this.isDistributorTarget) {
      this.distributorSetupService.targetTemplate().subscribe(b => saveAs(b as Blob, 'Distributor target template.xlsx'));
      return;
    }
    if (!this.fileType || !this.selectedDate || this.message == 'loading')
      return;

    this.salesFileService.downloadCsvTemplate(this.fileType.id).subscribe(response => {

      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      if (this.fileType.id == 1)
        anchor.download = "IbnSina.csv";
      else if (this.fileType.id == 2)
        anchor.download = "POS.csv";
      else if (this.fileType.id == 3)
        anchor.download = "UCP.csv";
      else if (this.fileType.id == 4)
        anchor.download = "EgyDrug.csv";
      else if (this.fileType.id == 5)
        anchor.download = "Dirct.csv";
      else if (this.fileType.id == 6)
        anchor.download = "Target.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);

    },
      err => { console.log(err); });
  }

  uploadFile() {
    if (this.isDistributorTarget) {
      this.pickDistributorTarget(false);
      return;
    }
    if (!this.fileType || !this.selectedDate || this.message == 'loading')
      return;
    document.getElementById('choosefile').click();
  }


  confirmDelete(itemId) {
    this.selectedFileId = itemId;
    this.deleteModal.show();
    //this.alertService.showDialog(this.translateService.getTranslation("DeleteConfirmationMessage"), DialogType.Confirm,
    //  () => this.delete(itemId),
    //  () => this.alertService.showMessage(this.translateService.getTranslation("OperationCancelled"), "", MessageSeverity.Default));

  }

  deleteOldFile() {
    this.hideDeleteOldFileModal();
    this.salesFileService.delete(this.selectedFileId).subscribe(response => {
      if (response == false) {
        this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);
      }
      else {
        this.alertService.showMessage("", this.translateService.getTranslation("DeletedSuccessfully"), MessageSeverity.Success);
        this.filesData = this.filesData.filter(x => x.id != this.selectedFileId);
        this.uploadDistributorFile();
      }

    }, err => {

      this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);

    });
  }

  delete() {
    this.hideDeleteModal();
    this.salesFileService.delete(this.selectedFileId).subscribe(response => {
      if (response == false) {
        this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);
      }
      else {
        this.alertService.showMessage("", this.translateService.getTranslation("DeletedSuccessfully"), MessageSeverity.Success);
        if (this.salesType == SalesFileType.target)
          this.getSalesFileData();
        else if (this.salesType == SalesFileType.sales)
          this.getSalesFileDistributorsData();
        else if (this.salesType == SalesFileType.pharmacy)
          this.getPharmacySalesFileData();
      }

    }, err => {

      this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);

    });
  }

  @ViewChild('sheetMapping') sheetMapping: SheetMappingComponent;
  private onMappedUpload: (res: any) => void;

  /** The template's column names (its first line), to match the picked sheet's columns against. */
  private templateFields(template: Observable<Blob>, then: (fields: string[]) => void) {
    template.subscribe(blob => {
      const reader = new FileReader();
      reader.onload = () => then((parseCsv(String(reader.result || ''))[0] || []).map(f => f.trim()).filter(f => f));
      reader.readAsText(blob);
    }, () => this.alertService.showMessage("", "Couldn't load the template's columns", MessageSeverity.Error));
  }

  /** Target tab (and the other file types there): match the sheet's columns to the template, then upload. */
  upload(files) {
    if (files.length === 0)
      return;
    const file = files[0];
    this.templateFields(this.salesFileService.downloadCsvTemplate(this.fileType.id), fields => {
      this.onMappedUpload = res => {
        if (res && res.isError) {
          this.error = true;
          this.message = "uploaded with error";
          this.downloadTargetErrorFile();
        } else {
          this.error = false;
          this.message = "uploaded success";
        }
        this.getSalesFileData();
      };
      this.sheetMapping.open(file, fields, mapped => {
        const formData = new FormData();
        formData.append(mapped.name, mapped);
        return this.salesFileService.provision(formData, this.fileType.id, this.selectedDate, this.applyDistributorPrice, true, true);
      });
    });
  }

  /** Sales tab: match the sheet's columns to the distributor sales template, then upload. */
  uploadDistributor(files) {
    if (files.length === 0)
      return;
    const file = files[0];
    const distributorId = this.fileType.id;
    this.distributorBranchService.search('', distributorId).subscribe(branches => {
      const hasBranches = ((branches as any[]) || []).length > 0;
      this.openDistributorMapping(file, distributorId, hasBranches);
    }, () => this.openDistributorMapping(file, distributorId, true));
  }

  /** The distributor sales template: rows are by branch or by brick (not both); without branches the branch column is ignored. */
  private openDistributorMapping(file: File, distributorId: number, hasBranches: boolean) {
    const notes = ['Upload per branch or per brick, not both: match either "branch code" or "brick code".'];
    if (!hasBranches)
      notes.push('This distributor has no branches: the "branch code" column is ignored, rows go by "brick code".');
    const options = {
      required: ['item code', 'stock units', 'sales units', 'free units'],
      exactlyOne: ['branch code', 'brick code'],
      ignored: hasBranches ? [] : ['branch code'],
      notes
    };
    this.templateFields(this.salesFileService.downloadDistributorSalesCSVTemplate(), fields => {
      this.onMappedUpload = res => {
        if (res && res.isError) {
          this.error = true;
          this.message = "uploaded with error";
          this.downloadCSVTemplatErrorFile();
        } else {
          this.error = false;
          this.message = "uploaded success";
        }
        this.getSalesFileDistributorsData();
      };
      this.sheetMapping.open(file, fields, mapped => {
        const formData = new FormData();
        formData.append(mapped.name, mapped);
        return this.salesFileService.uploadDistributorSalesWithProgress(formData, distributorId, this.selectedDate, this.applyDistributorPrice);
      }, options);
    });
  }

  mappedUploadDone(res: any) {
    if (this.onMappedUpload) this.onMappedUpload(res);
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  hideDeleteOldFileModal() {
    this.deleteOldFileModal.hide();
  }

  onChangeSalesMode(salesType) {
    this.message = "";
    this.selectedDate = undefined;
    //this.isSales = isSales;
    if (salesType == 'target') {
      this.salesType = SalesFileType.target;
      this.getFilesType();
      this.getSalesFileData();
    }
    else if (salesType == 'sales') {
      this.salesType = SalesFileType.sales;
      this.getDitributors();
      this.getSalesFileDistributorsData();
    }
    else if (salesType == 'pharmacy') {
      this.salesType = SalesFileType.pharmacy;
      this.getDitributors();
      this.getPharmacySalesFileData();
    }
  }

  downloadDistributorCSVTemplate() {
    this.salesFileService.downloadDistributorSalesCSVTemplate().subscribe(response => {
      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "DistributorSalesTemplate.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);
    },
      err => { console.log(err); });
  }

  normalizeDate(d:Date) {
    //let d = new Date(dateStr);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  }

  uploadDistributorFile() {
    const normalize = (d: Date) =>
      `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;


    if (!this.fileType || !this.selectedDate || this.message == 'loading')
      return;

    if (this.salesType == SalesFileType.sales) {
     // let ff = this.filesData[0];
     // //this.selectedDate.setHours(0, 0, 0, 0)
     // //let selectedDateStr = this.selectedDate.toISOString();
     // const isoDate = new Date(ff.insertedDate);

     //let cc=  normalize(this.selectedDate)
     // let vv = normalize(isoDate)

      let fileExistInSameDay = this.filesData.find(x => x.distributorId == this.fileType.id && normalize(this.selectedDate) == normalize(new Date(x.insertedDate)));

      if (fileExistInSameDay) {
        this.selectedFileId = fileExistInSameDay.id;
        this.deleteOldFileModal.show();
      } else {
        document.getElementById('chooseDistributorfile').click();
      }
    }
    else {
      document.getElementById('chooseDistributorfile').click();
    }


  }

  downloadTargetErrorFile() {
    this.salesFileService.downloadTargetErrorFile().subscribe(response => {
      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "TargetError.csv";
      anchor.href = url;
      anchor.click();
    }, err => {
      console.log(err);
    });
  }

  downloadCSVTemplatErrorFile() {
    this.salesFileService.downloadDistributorSalesErrorFile().subscribe(response => {
      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "Error.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);
    },
      err => {
        console.log(err);
      });
  }


  downloadPharmacySalesCSVTemplate() {
    this.salesFileService.downloadPharmacySalesCSVTemplate().subscribe(response => {
      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "PharmacySalesTemplate.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);
    },
      err => { console.log(err); });
  }


  uploadPharmacyFile() {
    if (!this.fileType || !this.selectedDate || this.message == 'loading')
      return;
    document.getElementById('choosePharmacyfile').click();
  }

  uploadPharmacy(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);

    this.error = false;
    this.message = "Loading .....";
    this.uploadJobs.run(this.salesFileService.uploadPharmacySalesWithProgress(formData, this.fileType.id, this.selectedDate, this.applyDistributorPrice)).subscribe(state => {
      this.uploadState = state;
      if (!state.done) return;
      if (state.error) { this.error = true; this.message = state.error; return; }
      let res = (state.result || {}) as any;
      if (res.isError) {
        this.error = true;
        this.message = "uploaded with error";
        this.downloadPharmacySalesErrorFile();
      }
      else {
        this.message = "uploaded success";
      }
      this.getPharmacySalesFileData();
    });
  }

  downloadPharmacySalesErrorFile() {
    this.salesFileService.downloadPharmacySalesErrorFile().subscribe(response => {
      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "Error.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);
    },
      err => {
        console.log(err);
      });
  }

}
